import {createContext} from 'react'

export const LegalContext = createContext<{
  acknowledgeUserDataProtectionPrivacy: () => void
  userAcknowledgedDataProtectionPrivacy: boolean | undefined
}>({
  acknowledgeUserDataProtectionPrivacy: () => {},
  userAcknowledgedDataProtectionPrivacy: undefined
})
